import { RouteComponentProps } from "@reach/router";
import React, { lazy } from "react";
import Layout from "../components/Layout";

// lazy load the core components
//const NearbyPlaces = lazy(() => import("../components/NearbyPlaces"));
const ShareMUGIS = lazy(() => import("../components/ShareMUGIS"));
const SearchContent = lazy(() => import("../components/SearchContent"));
const List = (props: RouteComponentProps) => {
  return (
    <Layout>
      <ShareMUGIS />
      <SearchContent />
    </Layout>
  );
};

export default List;
